import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const InstituteApprovalCard = ({ institute, onApprove, onReject, onViewDetails }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 transition-smooth hover:shadow-md">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="w-full md:w-32 h-32 flex-shrink-0 overflow-hidden rounded-lg bg-muted">
          <Image
            src={institute?.logo}
            alt={institute?.logoAlt}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-4 mb-3">
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-heading font-semibold text-foreground mb-1 truncate">
                {institute?.name}
              </h3>
              <p className="text-xs text-muted-foreground font-mono mb-2">
                ID: {institute?.id?.substring(0, 8) || 'N/A'}...
              </p>
              <p className="text-sm text-muted-foreground line-clamp-2">
                {institute?.description}
              </p>
            </div>
            <span className="px-3 py-1 bg-warning/10 text-warning text-xs font-medium rounded-full whitespace-nowrap">
              Pending Review
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">{institute?.location}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="BookOpen" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">{institute?.coursesCount} Courses</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground data-text">Applied: {institute?.appliedDate}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Store" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">Booth: {institute?.boothType}</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            <Button
              variant="default"
              size="sm"
              iconName="Check"
              onClick={() => onApprove(institute)}
            >
              Approve
            </Button>
            <Button
              variant="destructive"
              size="sm"
              iconName="X"
              onClick={() => onReject(institute)}
            >
              Reject
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Eye"
              onClick={() => onViewDetails(institute?.id)}
            >
              View Details
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstituteApprovalCard;